import React, { createContext, useState } from "react";

interface PageScaffoldContextProps {
  contentElement: HTMLDivElement | null; // State, not a ref: a page mounted late must re-run the layout padding
  setContentElement: (element: HTMLDivElement | null) => void;
}

const PageScaffoldContext = createContext<PageScaffoldContextProps | null>(null);

export const PageScaffoldProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [contentElement, setContentElement] = useState<HTMLDivElement | null>(null);

  return (
    <PageScaffoldContext.Provider
      value={{
        contentElement,
        setContentElement,
      }}
    >
      {children}
    </PageScaffoldContext.Provider>
  );
};

export default PageScaffoldContext;
